/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * The small inline note shown under a control. Moved out of
 * ActionButtonsSection unchanged, so the conditional-value dialog can use the
 * same one rather than a lookalike.
 */

import React from 'react';

export default function Hint({ children, tone = 'muted' }) {
  const colour = tone === 'warn' ? 'text-warning-emphasis' : '';
  return (
    <div className={`form-text d-flex align-items-start gap-1 ${colour}`}>
      <i className="bi bi-info-circle flex-shrink-0" style={{ marginTop: 2 }} aria-hidden="true" />
      <span>{children}</span>
    </div>
  );
}
